import React, { useEffect } from 'react';

import { fetchBlogPreview } from 'Redux/ducks/blog';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';

const BlogPreviewContainer = () => {
  const token = getUrlParameter('token') || '';

  useEffect(() => {
    if (token) {
      fetchBlogPreview(token);
    }
  }, [token]);

  return (
    <div><h1>Loading Preview</h1></div>
  );
};

export default BlogPreviewContainer;
